var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.target
    ? _c("div", { staticClass: "vacancy-box" }, [
        _c("h1", { staticClass: "vacancy-box__title" }, [
          _vm._v(_vm._s(_vm.target.title))
        ]),
        _vm.target.company
          ? _c("p", { staticClass: "vacancy-box__company" }, [
              _c("strong", [_vm._v(_vm._s(_vm.target.company.label) + ":")]),
              _vm._v(" " + _vm._s(_vm.target.company.name) + "\n\t")
            ])
          : _vm._e(),
        _vm.target.city
          ? _c("p", { staticClass: "vacancy-box__city" }, [
              _c("strong", [_vm._v(_vm._s(_vm.target.city.label) + ":")]),
              _vm._v(" " + _vm._s(_vm.target.city.name) + "\n\t")
            ])
          : _vm._e(),
        _vm.target.text && _vm.target.text.length
          ? _c(
              "ul",
              { staticClass: "vacancy-box__text" },
              _vm._l(_vm.target.text, function(textItem) {
                return _c("li", { staticClass: "vacancy-box__text-item" }, [
                  _c("strong", [_vm._v(_vm._s(textItem.title) + ":")]),
                  textItem.items && textItem.items.length
                    ? _c(
                        "ul",
                        _vm._l(textItem.items, function(item) {
                          return _c("li", [_vm._v(_vm._s(item))])
                        }),
                        0
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e(),
        _c("h2", { staticClass: "vacancy-box__title" }, [
          _vm._v(_vm._s(_vm.form.title))
        ]),
        _vm.form
          ? _c(
              "form",
              {
                ref: "form",
                staticClass: "vacancy-box__form",
                attrs: { action: "/form/resume", method: "post" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.sendForm($event)
                  }
                }
              },
              [
                _c("input", {
                  ref: "hiddenField",
                  attrs: { type: "hidden", name: "vacancy-code" },
                  domProps: { value: _vm.target.code }
                }),
                _c(
                  "form-field",
                  _vm._b(
                    {
                      staticClass: "vacancy-box__form-field",
                      attrs: {
                        clear: _vm.isClear,
                        invalid: _vm.invalid["fullname"]
                      }
                    },
                    "form-field",
                    _vm.form.fullname,
                    false
                  )
                ),
                _c(
                  "div",
                  { staticClass: "vacancy-box__form-row" },
                  [
                    _c(
                      "form-field",
                      _vm._b(
                        {
                          staticClass: "vacancy-box__form-field",
                          attrs: {
                            clear: _vm.isClear,
                            invalid: _vm.invalid["mail"]
                          }
                        },
                        "form-field",
                        _vm.form.mail,
                        false
                      )
                    ),
                    _c(
                      "form-field",
                      _vm._b(
                        {
                          staticClass: "vacancy-box__form-field",
                          attrs: {
                            clear: _vm.isClear,
                            invalid: _vm.invalid["phone"]
                          }
                        },
                        "form-field",
                        _vm.form.phone,
                        false
                      )
                    )
                  ],
                  1
                ),
                _c(
                  "form-field",
                  _vm._b(
                    {
                      staticClass: "vacancy-box__form-field",
                      attrs: {
                        clear: _vm.isClear,
                        invalid: _vm.invalid["letter"]
                      }
                    },
                    "form-field",
                    _vm.form.letter,
                    false
                  )
                ),
                _c("form-file", {
                  attrs: {
                    label: _vm.form.file.label,
                    name: "files",
                    invalid: _vm.invalid["files"],
                    clear: _vm.clearFile
                  },
                  on: { change: _vm.onFileChange }
                }),
                _c(
                  "div",
                  { staticClass: "vacancy-box__form-foot" },
                  [
                    _c(
                      "btn",
                      {
                        staticClass:
                          "btn btn--primary vacancy-box__form-submit",
                        attrs: { tag: "control" }
                      },
                      [_vm._v(_vm._s(_vm.submitText))]
                    ),
                    _c(
                      "form-checkbox",
                      _vm._b(
                        { staticClass: "vacancy-box__form-checkbox" },
                        "form-checkbox",
                        _vm.form.checkbox,
                        false
                      )
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-439b5f70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-439b5f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Vacancy.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-439b5f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Vacancy.vue
// module chunks = 0